export default {
  dataCacheTableRows: null,
  dataCacheErrRecordExcel: null,
  dataCacheFileNameExxel: null,
}
